/* Pure Limitless v3 (spec 19, sections 4.2, 6, 7 and 8). One deferred IIFE,
   no dependencies of its own: it calls the theme's Shopify.getCart and
   clicks the existing cart link so assets/main.js opens the drawer. No
   scroll or wheel listeners: position is read through IntersectionObserver.
   Contents: plTrack; header menu and Buy now targeting; header bar state
   and the bottom bar; quantity sync; add to cart by fetch, then the drawer;
   demo purchase handling; FAQ and section view tracking. The numeral mask
   and every other scroll effect live in assets/nad-v3-motion.js. */
(() => {
  const w = window, d = document, h = d.documentElement;
  const IO = 'IntersectionObserver' in w;
  const calm = matchMedia('(prefers-reduced-motion: reduce)');
  const desk = matchMedia('(min-width:1024px)');
  const q = (s, r) => (r || d).querySelector(s);
  const qa = (s, r) => [...(r || d).querySelectorAll(s)];
  const io = (f, m) => new IntersectionObserver(f, { rootMargin: m });

  /* Analytics layer (7). Staging and demo traffic carry theme_role and
     mode so they can be filtered out downstream. */
  window.plTrack = function (name, params) {
    params = params || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, params); } catch (e) {}
  };
  const t = (name, p) => {
    p.theme_role = d.body.getAttribute('data-theme-role') || '';
    w.plTrack(name, p);
  };

  const form = q('#pl-pdp-form'), box = q('#hero-buy'), hdr = q('#v3-header');
  const bar = q('[data-v3-sticky]'), mc = q('#MiniCart'), mb = q('[data-v3-menu]'), mp = q('#v3-menu');
  /* link: Buy now outside the product page is a link to the product page
     (data-v3-link); the homepage has no product form. */
  const mode = q('[data-v3-buy][data-v3-demo]') ? 'demo' : form ? 'buy' : q('[data-v3-buy][data-v3-link]') ? 'link' : 'notify';
  const attr = (n) => box ? box.getAttribute(n) || '' : '';
  let fmt = d.createElement('textarea');
  fmt.innerHTML = attr('data-money-format').replace(/<[^>]*>/g, '');
  fmt = fmt.value;
  let past = 0, stops = 0, drawer = 0, menuOpen = 0, busy = 0, last = null, sy = 0, armed = null;

  const price = () => +attr('data-v3-price');
  const qty = () => +(q('#pl-qty') || {}).value || 1;
  const money = (c) => {
    const v = (c / 100).toFixed(2), re = /\{\{\s*\w+\s*\}\}/;
    return re.test(fmt) ? fmt.replace(re, v) : fmt + v;
  };

  /* Quantity (6.3): #pl-qty is the only named field; [data-v3-qty] inputs
     mirror it. Updates the receipt quantity and subtotal. */
  const setQty = (n, track) => {
    const u = price();
    n = Math.max(1, Math.min(10, parseInt(n, 10) || 1));
    qa('#pl-qty,[data-v3-qty]').forEach((i) => { i.value = n; });
    qa('[data-v3-qty-text]').forEach((e) => { e.textContent = n; });
    if (u) qa('[data-v3-subtotal]').forEach((e) => { e.textContent = money(n * u); });
    if (track) t('select_purchase_option', { option_type: 'quantity', value: n });
  };

  /* One persistent buy control per viewport (6.4): the header bar state
     from 1024px, the bottom bar below. */
  const upd = () => {
    const on = past && box, s = !!(on && !desk.matches && !stops && !drawer && !menuOpen);
    if (hdr) on && desk.matches ? hdr.setAttribute('data-v3-bar', 'on') : hdr.removeAttribute('data-v3-bar');
    if (bar) {
      bar.classList.toggle('is-shown', s);
      bar.toggleAttribute('inert', !s);
      h.classList.toggle('v3-bar-on', s);
    }
    /* v3.1c: under 1024px, while a sticky-stop block (purchase panel, final
       CTA) is in view, its own Buy now is the only one: the header one hides
       too (visibility, so the header row never shifts). */
    h.classList.toggle('v3-stop-on', !!(on && stops && !desk.matches));
  };
  const ctl = q('[data-v3-buy="hero"]');
  if (ctl && IO) {
    io((es) => { past = !es[es.length - 1].isIntersecting; upd(); }, '-64px 0px 99999px 0px').observe(ctl);
    const so = io((es) => {
      es.forEach((x) => {
        if (x.target.v3in !== x.isIntersecting) { stops += x.isIntersecting ? 1 : -1; x.target.v3in = x.isIntersecting; }
      });
      upd();
    });
    qa('[data-v3-sticky-stop]').forEach((x) => { x.v3in = false; so.observe(x); });
  }
  desk.addEventListener('change', upd);

  /* Mobile menu: a disclosure panel under the bar. */
  const menu = (o, back) => {
    menuOpen = o;
    mb.setAttribute('aria-expanded', !!o);
    mp.hidden = !o;
    upd();
    if (o) q('a', mp).focus(); else if (back) mb.focus();
  };

  /* Drawer. Opening goes through the theme's cart link so assets/main.js
     keeps aria-expanded and focus. After a close that follows a buy click,
     the page position is kept and focus returns to that buy control. */
  const openDrawer = () => {
    const a = q('.shopping-cart a.cart-count');
    sy = w.pageYOffset;
    if (a) a.click();
    if (mc && !mc.classList.contains('show')) {
      mc.classList.add('show');
      q('.mm-fullscreen-bg')?.classList.add('active');
    }
  };
  if (mc) {
    new MutationObserver(() => {
      const o = mc.classList.contains('show');
      if (o === !!drawer) return;
      drawer = o;
      if (o) { const m = q('[data-v3-cart-msg]', mc); if (m) { m.textContent = ''; m.classList.remove('is-error'); } }
      upd();
      if (!o && last) {
        w.scrollTo({ top: sy, behavior: 'instant' });
        last.focus({ preventScroll: true });
        last = null;
      }
    }).observe(mc, { attributes: true, attributeFilter: ['class'] });
  }

  /* Drawer lines (6.6). The markup lives only in
     snippets/mini-cart-drawer.liquid: a change posts to /cart/change.js with
     the header section (Section Rendering API) and the returned
     [data-v3-cart-body] replaces the current one. Stepper taps update the
     number at once and are sent after a short pause, one request at a
     time, so fast taps add up. Focus returns to the same control. */
  const SEC = 'nad-v3-header';
  const root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  let chain = Promise.resolve();
  const timers = {};
  const cartMsg = (m, err) => {
    const s = mc && q('[data-v3-cart-msg]', mc);
    if (!s) return;
    s.classList.toggle('is-error', !!err);
    s.textContent = m || '';
  };
  const lineOf = (key) => mc && qa('[data-v3-cart-line]', mc).find((x) => x.getAttribute('data-v3-cart-line') === key);
  const swap = (html, keep) => {
    const ob = mc && q('[data-v3-cart-body]', mc);
    if (!ob || !html) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nb = q('[data-v3-cart-body]', doc);
    if (!nb) return false;
    const had = mc.contains(d.activeElement);
    ob.replaceWith(d.importNode(nb, true));
    const n = nb.getAttribute('data-count');
    qa('.bigcounter').forEach((b) => { b.textContent = n; });
    if (keep && had) {
      const line = lineOf(keep.key);
      let el = line && q(keep.sel, line);
      if (el && el.disabled) el = q('[data-v3-cart-qty]', line);
      if (!el) el = q('[data-v3-cart-remove], .v3-cart__empty a', mc) || q('.v3-cart__close', mc);
      if (el) el.focus({ preventScroll: true });
    }
    return true;
  };
  const cartRefresh = (keep) => fetch(`${location.pathname}?sections=${SEC}`, { credentials: 'same-origin' })
    .then((r) => r.json()).then((j) => { swap(j[SEC], keep); }).catch(() => {});
  w.plCartRefresh = () => cartRefresh();
  const send = (key, n, keep) => {
    chain = chain.then(() => {
      mc.setAttribute('aria-busy', 'true');
      return fetch(`${root}cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: n, sections: SEC, sections_url: location.pathname })
      }).then((r) => r.json().catch(() => ({})).then((j) => {
        if (!r.ok) {
          cartMsg(j.description || j.message || 'The cart could not be updated.', 1);
          return cartRefresh(keep);
        }
        cartMsg(n ? 'Cart updated.' : 'Item removed.');
        t('cart_update', { quantity: n, item_count: j.item_count });
        if (!swap(j.sections && j.sections[SEC], keep)) return cartRefresh(keep);
      })).catch(() => { cartMsg('The cart could not be updated.', 1); })
        .finally(() => mc.removeAttribute('aria-busy'));
    });
    return chain;
  };
  if (mc) {
    mc.addEventListener('click', (e) => {
      const el = e.target, line = el.closest('[data-v3-cart-line]');
      if (!line) return;
      const key = line.getAttribute('data-v3-cart-line'), inp = q('[data-v3-cart-qty]', line);
      let x;
      if ((x = el.closest('[data-v3-cart-step]'))) {
        const st = +x.getAttribute('data-v3-cart-step');
        const n = Math.max(1, (parseInt(inp.value, 10) || 1) + st);
        inp.value = n;
        const dec = q('[data-v3-cart-step="-1"]', line);
        if (dec) dec.disabled = n <= 1;
        clearTimeout(timers[key]);
        timers[key] = setTimeout(() => send(key, n, { key, sel: `[data-v3-cart-step="${st}"]` }), 350);
      } else if (el.closest('[data-v3-cart-remove]')) {
        clearTimeout(timers[key]);
        send(key, 0, { key, sel: '[data-v3-cart-remove]' });
      }
    });
    mc.addEventListener('change', (e) => {
      const inp = e.target;
      if (!inp.matches('[data-v3-cart-qty]')) return;
      const line = inp.closest('[data-v3-cart-line]'), key = line.getAttribute('data-v3-cart-line');
      const n = parseInt(inp.value, 10);
      clearTimeout(timers[key]);
      if (isNaN(n) || n < 0) return cartRefresh({ key, sel: '[data-v3-cart-qty]' });
      send(key, n, { key, sel: '[data-v3-cart-qty]' });
    });
    mc.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.matches('[data-v3-cart-qty]')) {
        e.preventDefault();
        e.target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  const status = (msg, err) => {
    const s = q('#pl-status');
    if (!s) return;
    s.className = err ? 'v3-buy__error' : 'visually-hidden';
    s.setAttribute('role', err ? 'alert' : 'status');
    s.textContent = msg;
  };
  const demo = (b) => {
    last = b;
    openDrawer();
    status('Demo purchase state. Nothing was added to the cart.');
  };
  const goNotify = () => setTimeout(() => q('#buy-notify input[type="email"]')?.focus({ preventScroll: true }), 60);

  /* Add to cart (6.4): every buy button submits #pl-pdp-form. A failed
     request falls back to the native submit, which lands on /cart. */
  d.addEventListener('submit', (e) => {
    const f = e.target;
    // getAttribute: a product form's input name="id" shadows f.id.
    if (f.getAttribute('id') !== 'pl-pdp-form' || !w.fetch) return;
    e.preventDefault();
    if (busy) return;
    busy = 1;
    const btns = qa('[data-pl-atc]'), was = btns.map((x) => x.disabled);
    btns.forEach((x) => { x.disabled = true; x.setAttribute('aria-busy', 'true'); });
    const end = () => {
      busy = 0;
      btns.forEach((x, i) => { x.disabled = was[i]; x.removeAttribute('aria-busy'); });
    };
    fetch(f.action + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(f)
    }).then((r) => r.json().catch(() => ({})).then((j) => {
      end();
      if (!r.ok) return (last = null), status(j.description || j.message || 'This item could not be added to the cart.', 1);
      status('');
      const li = q('.v3-hdr__cartli'), dm = q('.v3-cart__demo');
      if (li) li.hidden = false;
      if (dm) dm.hidden = true;
      openDrawer();
      cartRefresh().then(() => {
        const b = q('[data-v3-cart-body]', mc);
        t('cart_drawer_view', { item_count: b ? +b.getAttribute('data-count') || 0 : 0 });
      });
    }), () => { end(); f.submit(); });
  });

  const buyClick = (b, e) => {
    const loc = b.getAttribute('data-v3-buy'), inBar = hdr?.hasAttribute('data-v3-bar');
    const sticky = loc === 'sticky' || (loc === 'header' && inBar), p = { mode };
    if (loc === 'hero' || sticky) { p.quantity = qty(); p.price = price() / 100; }
    if (loc === 'hero') {
      p.currency = w.Shopify?.currency?.active;
      t('hero_buy_click', p);
    } else if (sticky) {
      p.surface = loc === 'sticky' ? 'bar' : 'header';
      t('sticky_buy_click', p);
    } else {
      p.location = loc;
      t('buy_click', p);
    }
    if (b.hasAttribute('data-v3-link')) return;
    last = mode === 'notify' ? null : b;
    if (loc === 'header' && box) {
      if (inBar && mode !== 'notify') {
        e.preventDefault();
        if (mode === 'demo') demo(b); else form.requestSubmit ? form.requestSubmit() : form.submit();
        return;
      }
      const gone = box.getBoundingClientRect().bottom < 0;
      b.setAttribute('href', inBar ? '#buy-notify' : gone && q('#buy') ? '#buy' : '#hero-buy');
      if (inBar) goNotify();
      else if (!gone && !calm.matches) {
        box.classList.add('is-flash');
        setTimeout(() => box.classList.remove('is-flash'), 600);
      }
    } else if (b.hasAttribute('data-v3-demo')) { e.preventDefault(); demo(b); }
    else if (mode === 'notify') goNotify();
  };

  d.addEventListener('click', (e) => {
    const el = e.target;
    let x;
    if ((x = el.closest('[data-v3-step]'))) {
      const i = q('input', x.closest('.v3-qty') || x.parentNode);
      setQty((+(i || {}).value || 1) + +x.getAttribute('data-v3-step'), 1);
    } else if ((x = el.closest('[data-v3-buy]'))) buyClick(x, e);
    else if (el.closest('a[href$="#buy-notify"]')) goNotify();
    else if ((x = el.closest('details.v3-acc>summary'))) armed = x.parentNode;
    else if (mp && el.closest('[data-v3-menu]')) menu(!menuOpen);
    else if (mp && el.closest('#v3-menu a')) menu(0);
  });
  d.addEventListener('change', (e) => {
    const x = e.target;
    if (x.matches('#pl-qty,[data-v3-qty]')) setQty(x.value, 1);
    else if (x.name === 'selling_plan') t('select_purchase_option', { option_type: 'selling_plan', value: x.value });
  });
  d.addEventListener('keydown', (e) => {
    if (menuOpen && /^Esc/.test(e.key)) menu(0, 1);
  });

  /* FAQ: count items the visitor opens, not the item rendered open. */
  d.addEventListener('toggle', (e) => {
    const x = e.target;
    if (x !== armed || !x.open) return;
    armed = null;
    t('faq_open', { question: q('summary', x).textContent.trim(), index: qa('details.v3-acc').indexOf(x) + 1 });
  }, true);

  if (IO) {
    /* Section views, once each. */
    const sv = io((es) => es.forEach(({ isIntersecting, target: s }) => {
      if (!isIntersecting) return;
      sv.unobserve(s);
      if (s.id === 'buy') t('purchase_section_view', { mode });
      else t('review_section_view', { state: s.getAttribute('data-v3-review-state') || (q('[data-marker]', s) ? 'placeholder' : 'empty') });
    }), '0px 0px -40% 0px');
    ['#reviews', '#buy'].forEach((id) => { const s = q(id); if (s) sv.observe(s); });
  }

  setQty(qty());
  upd();
})();
